import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  connect() { this.activate(this.tabTargets.findIndex(tab => tab.getAttribute("aria-selected") === "true")) }

  select(event) { this.activate(this.tabTargets.indexOf(event.currentTarget)) }

  navigate(event) {
    const keys = ["ArrowLeft", "ArrowRight", "Home", "End"]
    if (!keys.includes(event.key)) return
    event.preventDefault()
    const tabs = this.tabTargets
    const index = tabs.indexOf(event.currentTarget)
    const next = event.key === "Home" ? 0 : event.key === "End" ? tabs.length - 1 : (index + (event.key === "ArrowRight" ? 1 : -1) + tabs.length) % tabs.length
    this.activate(next)
    tabs[next].focus()
  }

  activate(index) {
    const active = Math.max(0, index)
    this.tabTargets.forEach((tab, i) => {
      tab.setAttribute("aria-selected", String(i === active))
      tab.tabIndex = i === active ? 0 : -1
    })
    this.panelTargets.forEach((panel, i) => { panel.hidden = i !== active })
  }
}
